import useRouter from '../useRouter';
import useFeatureToggle from '../useFeatureToggle';
import { PageType } from './types';
import { getPageTypeByUrl } from './pageTypeService';

export const bellaPageTypes = [
    PageType.ALLPRODUCTS,
    PageType.NEWPRODUCTS,
    PageType.LANDING,
    PageType.BRANDS,
    PageType.CATEGORY,
    PageType.HOMEPAGE,
    PageType.PDP,
    PageType.WISHLIST,
    // TODO: enable once feature toggle is removed https://westwing.jira.com/browse/P100-3126
    // PageType.INTERIOR_DESIGN_SERVICE,
    // TODO: enable once cart feature toggle is removed
    // PageType.CART,
    // PageType.CART_NATIVE,
    PageType.LOOKS,
];

const useCurrentPageType = () => {
    const {
        location: { pathname },
        host,
    } = useRouter();

    return getPageTypeByUrl(pathname, host);
};

const useIsBellaPageType = () => {
    const { host } = useRouter();
    const { p100IdsClientSideNavigation, shopBellaCart } = useFeatureToggle();

    const bellaPagesFromFeatureToggles = [];

    // TODO: remove logic once feature toggle is removed https://westwing.jira.com/browse/P100-3126
    if (p100IdsClientSideNavigation) {
        bellaPagesFromFeatureToggles.push(PageType.INTERIOR_DESIGN_SERVICE);
    }

    if (shopBellaCart) {
        bellaPagesFromFeatureToggles.push(PageType.CART);
        bellaPagesFromFeatureToggles.push(PageType.CART_NATIVE);
    }

    const finalBellaPageTypes = [...bellaPageTypes, ...bellaPagesFromFeatureToggles];

    return (url: string) => {
        const { pageType, relativeUrl } = getPageTypeByUrl(url, host);
        return { isBellaPage: finalBellaPageTypes.includes(pageType), relativeUrl };
    };
};

export { useCurrentPageType, useIsBellaPageType, PageType };
